import React from 'react';
import { Form } from 'antd';
import useTranslation from '../../../hooks/translation/useTranslation';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';
import CustomerPasswordInput from '../../inputs/customerPasswordInput/CustomerPasswordInput';

function SubmitPasswordRecoveryForm({ form, handleSubmit, loading }) {
  const { trans } = useTranslation();
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <CustomerPasswordInput
        label={trans('new_password')}
        name="password"
        rules={[
          {
            required: true,
            message: trans('input_necessary'),
          }, {
            min: 8,
            message: trans('password_min_8_length'),
          },
        ]}
      />
      <CustomerPasswordInput
        label={trans('repeat_new_password')}
        name="repeat_password"
        rules={[
          {
            required: true,
            message: trans('input_necessary'),
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject(trans('passwords_do_not_match'));
            },
          }),
        ]}
      />
      <div className="flex justify-center">
        <DefaultButton
          disabled={loading}
          type="submit"
          className="text-base leading-[22px] w-full lg:w-auto"
        >
          {trans('recover_password')}
        </DefaultButton>
      </div>
    </Form>
  );
}

export default SubmitPasswordRecoveryForm;
